'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userTimeline;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _actionTypes = require('../../actions/action-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function populateUserTimeline(state, action) {
  var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var feedUserKey = action && action.payload && action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
  if (feedUserKey && state[feedUserKey]) return Object.assign({}, state[feedUserKey], overwrite);
  return overwrite;
}

function userTimeline() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var feedUserKey = action && action.payload && action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
  var newTimeline = void 0;

  switch (action.type) {
    case _actionTypes.FAIL_MINI_PROFILE:
    case _actionTypes.FAIL_USER_TIMELINE:
      var failedUserTimeline = populateUserTimeline(state, action, { isFetching: false, isError: true });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, failedUserTimeline));

    case _actionTypes.REQUEST_MINI_PROFILE:
    case _actionTypes.REQUEST_USER_TIMELINE:
      var requestedUserTimeline = populateUserTimeline(state, action, { isFetching: true, isError: false });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, requestedUserTimeline));

    case _actionTypes.RECEIVE_MINI_PROFILE:
    case _actionTypes.RECEIVE_USER_TIMELINE:
      // TODO: We'll need to get smarter about this
      // For example, sorting by date when new items are added
      newTimeline = state[feedUserKey] && state[feedUserKey].feedItems ? state[feedUserKey].feedItems.slice() : [];
      var isEndOfTimeline = action.payload.response.feedItems && action.payload.response.feedItems.length === 0;
      var feedContentIds = _underscore2.default.map(action.payload.response.feedItems, function (f) {
        return f.content.feedContentId;
      });
      newTimeline = newTimeline.concat(feedContentIds);
      newTimeline = _underscore2.default.uniq(newTimeline);
      return Object.assign({}, state, _defineProperty({}, feedUserKey, {
        isEndOfTimeline: isEndOfTimeline,
        isError: false,
        isFetching: false,
        feedItems: newTimeline
      }));

    case _actionTypes.FAIL_DISMISS_FEED_ITEM:
      newTimeline = populateUserTimeline(state, action, {
        dismissFeedItem: {
          feedContentId: action.payload.feedContentId,
          isRequesting: false,
          isError: true
        } });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, newTimeline));

    case _actionTypes.REQUEST_DISMISS_FEED_ITEM:
      var currentDismissItem = state[feedUserKey].dismissFeedItem || {};
      currentDismissItem.feedContentId = action.payload.feedContentId;
      currentDismissItem.isRequesting = true;

      newTimeline = populateUserTimeline(state, action, {
        dismissFeedItem: currentDismissItem
      });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, newTimeline));

    case _actionTypes.SUCCESS_DISMISS_FEED_ITEM:
      var feedContentId = action.payload.feedContentId;
      var feedItems = state[feedUserKey] && state[feedUserKey].feedItems ? state[feedUserKey].feedItems.slice() : [];
      var itemIndex = feedItems.indexOf(feedContentId);
      if (itemIndex > -1) {
        feedItems.splice(itemIndex, 1);
      }
      newTimeline = populateUserTimeline(state, action, {
        feedItems: feedItems,
        dismissFeedItem: {
          feedContentId: feedContentId,
          isRequesting: false,
          isError: false
        } });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, newTimeline));

    case _actionTypes.HIDE_CONFIRM_DISMISS_FEED_ITEM:
      newTimeline = populateUserTimeline(state, action, { dismissFeedItem: null });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, newTimeline));

    case _actionTypes.SHOW_CONFIRM_DISMISS_FEED_ITEM:
      newTimeline = populateUserTimeline(state, action, {
        dismissFeedItem: {
          feedContentId: action.payload.feedContentId,
          isRequesting: false,
          isError: false
        } });
      return Object.assign({}, state, _defineProperty({}, feedUserKey, newTimeline));

    default:
      return state;
  }
}